<script lang="ts">
    import { isNative } from "@utils/underhood/browser"
</script>

{#if isNative}
    <div class="status-bar-backdrop" aria-hidden="true" />
{/if}

<style>
    .status-bar-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 24;
        height: max(var(--safe-area-inset-top, 0rem), 0rem);
        pointer-events: none;
        background: rgb(41 34 74 / 0.38);
        backdrop-filter: blur(14px);
        -webkit-backdrop-filter: blur(14px);
        border-bottom: 1px solid rgb(255 255 255 / 0.08);
    }

    @supports not (backdrop-filter: blur(1px)) {
        .status-bar-backdrop {
            background: rgb(41 34 74 / 0.58);
        }
    }
</style>
